import { Fragment, useMemo } from 'react';
import { getLogisticsLogHeaderItems } from '@lp/features/RoutePlanner/components/LogisticsChangeLog/utils';
import { ChangeLogItemProps } from '@lp/features/RoutePlanner/components/LogisticsChangeLog/consts';

export const ChangeLogHeader = ({ log }: ChangeLogItemProps) => {
  const textItems = useMemo(() => {
    return getLogisticsLogHeaderItems(log);
  }, [log]);

  return (
    <span>
      {textItems.map((item, index) => {
        if (index === textItems.length - 1) {
          return (
            <span key={`${log.id}-${item}`} className="text-m-sb text-base-5">
              {item}
            </span>
          );
        }

        return (
          <Fragment key={`${log.id}-${item}`}>
            <span className="text-m-sb text-base-5">{item}</span>
            <span className="text-m-r text-base-20">{` > `}</span>
          </Fragment>
        );
      })}
    </span>
  );
};
